/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import jMoment from 'moment-jalaali'
import {Checkbox, message} from 'antd'
import {Link} from 'react-router-dom'
import $ from 'jquery'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderGrid from '../Pagination/HeaderGrid'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import SortLocal from '../BaseComponent/sortLocal'

class ProductPlanTime extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      buttonClicked: false,
      list: [],
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تامین کننده',
          value: 'providerName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'دارای برنامه تامین',
          value: 'productsWithPlan',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'بدون برنامه تامین',
          value: 'productsWithoutPlan',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      checked: false,
      copyList: []
    }
  }

  submitForm(e) {
    e.preventDefault()
  }

  get componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  getReport = () => {
    let filter = this.createFilter()
    http
      .get(`suppliers/products/plans/time`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          console.log(response.data.object)
          this.setState({
            list: response.data.object,
            copyList: response.data.object,
            checked: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            listWareHouse: [],
            lengthList: 0
          })
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  createFilter = () => {
    let filter = {}
    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId
    let planDateMin = this.state.fromDate
    let planDateMax = this.state.toDate
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (driverId !== '') {
      filter.driverId = driverId
    }

    if (planDateMin !== '') {
      filter.fromTime = planDateMin
    }
    if (planDateMax !== '') {
      filter.toTime = planDateMax
    }

    return filter
  }

  filter() {
    this.getReport()
  }

  compareBy(key) {
    return function(a, b) {
      if (a[key] < b[key]) {
        return Number(a[key] - b[key])
      } else {
        return Number(b[key] - a[key])
      }
    }
  }

  getSort = (sort) => {
    let arrayCopy = this.state.list
    arrayCopy.sort(this.compareBy(sort.sortColumn))
    this.setState({list: arrayCopy})
  }

  changeCheckbox = () => {
    this.setState(
      {
        checked: !this.state.checked
      },
      () => {
        if (this.state.checked) {
          this.setState({
            copyList: this.state.list.filter((item) => item.productsWithPlan === 0)
          })
        } else {
          this.setState({
            copyList: this.state.list
          })
        }
      }
    )
  }

  render() {
    return (
      <div className="rtl printA4Page">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>وضعیت سفارشات</li>
            <li>گزارش مغایرت برنامه کاری تامین کتنندگان</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ ثبت از"
                  toLabel="تاریخ ثبت تا"
                  fromId="from"
                  toId="to"
                  defaulValue
                />
                <div className="pt-5 mx-3">
                  <Checkbox tabIndex="4" checked={this.state.checked} onChange={this.changeCheckbox}>
                    نمایش تامین کننده های بدون برنامه تامین
                  </Checkbox>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                {/*<thead>*/}
                {/*<tr>*/}
                {/*    <th>ردیف</th>*/}
                {/*    <th>تامین کننده</th>*/}
                {/*    <th>دارای برنامه تامین</th>*/}
                {/*    <th>بدون برنامه تامین</th>*/}
                {/*</tr>*/}
                {/*</thead>*/}
                <tbody>
                  <SortLocal data={this.state.sortData} getSort={this.getSort} />

                  {this.state.copyList.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.providerName}</td>
                      <td>{item.productsWithPlan}</td>
                      <td>{item.productsWithoutPlan}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProductPlanTime
